import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { chgInstance } from "../../redux/ReduxInstance";
import { Container, Table, Form, Button } from "react-bootstrap";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ComponentLoader from "../../components/layout/ComponentLoader";
import { apiRecupEspacesColidee } from "../../api/ApiColidee";
import { apiGetProcesses, apiUpdateProcesses } from "../../api/ApiProcess";
import { apiGetInstance, apiUpdateInstance } from "../../api/ApiInstance";

const PageAdminColidee = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const dispatch = useDispatch();
  const [espaces, setEspaces] = useState([]);
  const [espacesListe, setEspacesListe] = useState([]);
  const [processes, setProcesses] = useState([]);
  const [loader, setLoader] = useState(false);
  const [espacePrincipalColidee, setEspacePrincipalColidee] = useState({
    espacePrincipalColidee: ReduxInstance.espacePrincipalColidee,
  });

  const recupEspacesAndMacroProcess = async () => {
    const resProcess = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
    setProcesses(resProcess.data);

    const form = new FormData();
    form.append("entreprises", ReduxInstance.entreprisesColidee);
    const resEspaces = await apiRecupEspacesColidee(form);

    const resEspacesCopySortOneKey = [...resEspaces.data];
    const resEspacesCopySortTwoKey = [...resEspaces.data];
    // tri par 1 clé ascendante pour aliment la liste select
    resEspacesCopySortOneKey.sort((a, b) => (a.nom < b.nom ? -1 : 1));
    setEspacesListe(resEspacesCopySortOneKey);

    // tri par 2 clés ascendantes pour alimenter le tableu des espaces
    resEspacesCopySortTwoKey
      .sort((a, b) => (b.nom < a.nom ? -1 : 1))
      .sort((a, b) => (a.nom_entreprise < b.nom_entreprise ? -1 : 1));
    setEspaces(resEspacesCopySortTwoKey);
  };

  const submitData = async (e) => {
    setLoader(true);
    e.preventDefault();
    /* on récupère les valeurs des cases cochées et on les mets dans un tableau d'objets */
    const dataForm = [];
    var nouvelleTailledataForm = 0;
    for (const element of e.target) {
      let indexObjet = dataForm.findIndex((x) => x._id === element.name);
      if (indexObjet === -1 && element.type === "checkbox") {
        nouvelleTailledataForm = dataForm.push({ _id: element.name, espaces: [] });
        indexObjet = nouvelleTailledataForm - 1;
      }
      if (element.checked) {
        dataForm[indexObjet].espaces.push(element.value);
      }
    }

    await apiUpdateProcesses(dataForm);
    await apiUpdateInstance(ReduxInstance._id, espacePrincipalColidee);

    const res = await apiGetInstance(ReduxInstance._id, ReduxUserEmail);
    dispatch(chgInstance(res.data));

    setLoader(false);
  };

  useEffect(() => {
    recupEspacesAndMacroProcess();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminEspacesConcertation.titre")} />
        <label className="fw-bold mt-2">{t("commun.form.label.espacePrincipal")}</label>
        <Form onSubmit={submitData}>
          <Form.Select
            name="espacePrincipalColidee"
            value={espacePrincipalColidee.espacePrincipalColidee}
            onChange={(e) => setEspacePrincipalColidee({ espacePrincipalColidee: e.target.value })}
          >
            <option value="0">{t("admin.PageAdminEspacesConcertation.selectEspace")}</option>
            {espacesListe.map((espace, index) => (
              <option value={espace.id_plateforme} key={index}>
                {espace.nom}
              </option>
            ))}
          </Form.Select>

          <div className="text-end mt-2 mb-3">
            {!loader && (
              <Button variant="success" type="Submit">
                {t("commun.form.button.enregistrer")}
              </Button>
            )}
            {loader && <ComponentLoader />}
          </div>

          <label className="fw-bold mt-5">{t("commun.form.label.categoriesEspaces")}</label>
          <Table striped bordered hover className="stickyTable mt-2">
            <thead>
              <tr>
                <th>{t("admin.PageAdminEspacesConcertation.titreColonne1")}</th>
                <th>{t("admin.PageAdminEspacesConcertation.titreColonne2")}</th>
                {processes.map((process) => (
                  <th className="text-center" key={process._id}>
                    {process.nom}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {espaces.map((espace) => (
                <tr key={espace.id_plateforme}>
                  <td>{espace.nom_entreprise}</td>
                  <td>{espace.nom}</td>
                  {processes.map((process) => (
                    <td className="text-center" key={process._id}>
                      <Form.Check
                        name={process._id}
                        aria-label={espace.id_plateforme}
                        value={espace.id_plateforme}
                        defaultChecked={
                          process.espaces.includes(espace.id_plateforme) ? "checked" : ""
                        }
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="text-end mb-5">
            {!loader && (
              <Button variant="success" type="Submit">
                {t("commun.form.button.enregistrer")}
              </Button>
            )}
            {loader && <ComponentLoader />}
          </div>
        </Form>
      </Container>
    </>
  );
};

export default PageAdminColidee;
